export default {
  customerUsers: [],
  customerUser: undefined,
};
